import React from 'react';
import {observer} from 'mobx-react';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import Paper from "@material-ui/core/Paper";
import {SdmGame} from "../../services/sdm/sdm-game";
import {LauncherComponentWithState} from "../base-components/launcher-component-with-state";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from "@material-ui/core/FormLabel";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import GameTableRow from "./game-table-row/game-table-row";

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        marginTop: "10px"
    },
    paper: {
        border: '1px solid',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        textAlign: "center"
    },
    selectLabel: {
        display: 'block',
        fontWeight: 'bold'
    },
    select: {
        display: 'block',
        width: '10vw'
    },
    selectContainers: {
        display: "inline-block",
        margin: "4px",
        marginTop: '7px'
    },
    table: {
        border: "1px solid #2196f3",
        maxWidth: "99%",
        marginTop: '2px',
    },
    addColumn: {
        width: "5%"
    },
    gameTypeColumn: {
        width: "10%"
    },
    gameTitleColumn: {
        width: "auto"
    },
    companyColumn: {
        width: "10%"
    },
    vendorColumn: {
        width: "10%"
    }
});

const TableHeadCellWithStyles = (props) => {
    let StyledTableCell = withStyles((theme: Theme) =>
        createStyles({
            head: {
                backgroundColor: "#2196f3",
                color: theme.palette.common.white,
            }
        })
    )(TableCell);

    return <StyledTableCell align={"center"} {...props}/>
};

interface AddVendorGamesFromSdmComponentState {
    selectedCompany: string,
    selectedVendor: string,
}

export interface AddVendorGamesFromSdmComponentProps extends WithStyles<typeof styles> {

}

export const AddVendorGamesFromSdmComponent = withStyles(styles)(
    observer(
        class extends LauncherComponentWithState<AddVendorGamesFromSdmComponentProps, AddVendorGamesFromSdmComponentState> {

            constructor(props) {
                super(props);

                this.state = {
                    selectedCompany: "",
                    selectedVendor: "",
                }
            }

            private _handleSelection = (event) => {
                let selectedValue = event.target.value;
                let fieldName = event.target.name;
                this.setState((current) => ({
                    ...current,
                    [fieldName]: selectedValue
                }))
            };

            private _renderCompanySelector = () => {
                const {classes} = this.props;

                return (
                    <div className={classes.selectContainers}>
                        <FormLabel className={classes.selectLabel}>{"Company"}</FormLabel>
                        <Select name={"selectedCompany"}
                                className={classes.select}
                                onChange={this._handleSelection}
                                value={this.state.selectedCompany}
                                displayEmpty>
                            <MenuItem value={""}>{"None"}</MenuItem>
                            {this.services.sdm.companies.map((companyName, index) => <MenuItem key={index}
                                                                                               value={companyName}>{companyName}</MenuItem>)}
                        </Select>
                    </div>
                );
            };


            private _renderVendorSelector = () => {
                const {classes} = this.props;

                return (
                    <div className={classes.selectContainers}>
                        <FormLabel className={classes.selectLabel}>{"Vendor"}</FormLabel>
                        <Select name={"selectedVendor"}
                                className={classes.select}
                                onChange={this._handleSelection}
                                value={this.state.selectedVendor}
                                displayEmpty>
                            <MenuItem value={""}>{"None"}</MenuItem>
                            {this.services.sdm.vendors.map((vendorName, index) => <MenuItem key={index}
                                                                                            value={vendorName}>{vendorName}</MenuItem>)}
                        </Select>
                    </div>
                );

            };


            private _renderTable = (filteredGames: SdmGame[]) => {
                const {classes} = this.props;

                return (
                    <div style={{textAlign: "center", marginTop: '2px'}}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCellWithStyles className={classes.addColumn}>{"Add"}</TableHeadCellWithStyles>
                                        <TableHeadCellWithStyles
                                            className={classes.gameTypeColumn}>{"Gametype"}</TableHeadCellWithStyles>
                                        <TableHeadCellWithStyles
                                            className={classes.gameTitleColumn}>{"Title"}</TableHeadCellWithStyles>
                                        <TableHeadCellWithStyles
                                            className={classes.companyColumn}>{"Company"}</TableHeadCellWithStyles>
                                        <TableHeadCellWithStyles
                                            className={classes.vendorColumn}>{"Vendor"}</TableHeadCellWithStyles>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredGames.map(game => new GameTableRow(classes, game, this.services).render())}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                );
            };

            private _getFilteredGames = (allGames: SdmGame[]): SdmGame[] => {
                let selectedVendor = this.state.selectedVendor;
                let selectedCompany = this.state.selectedCompany;

                if (selectedCompany === "" && selectedVendor === "")
                    return [];
                let result = allGames;
                if (selectedCompany === "")
                    return result.filter(game => game.vendorName === selectedVendor);
                if (selectedVendor === "")
                    return result.filter(game => game.companyName === selectedCompany);
                return result.filter(game => game.companyName === selectedCompany)
                    .filter(game => game.vendorName === selectedVendor);
            };

            private _renderErrorMessageOrTable = (filteredGames: SdmGame[]) => {
                const {classes} = this.props;

                if (filteredGames && filteredGames.length === 0) {
                    if (!this.state.selectedCompany && !this.state.selectedVendor)
                        return <h3>You must select a company and/or vendor!</h3>;
                    return <h3>There are no games for the selected combination!</h3>
                }
                return (
                    <div className={classes.root}>
                        {this._renderTable(filteredGames)}
                    </div>);
            };

            render() {
                let filteredGames = this._getFilteredGames(this.services.sdm.allGames);

                return (
                    <div style={{marginLeft: '10px', marginBottom: '10px'}}>
                        <div>
                            {this._renderCompanySelector()}
                            {this._renderVendorSelector()}
                        </div>
                        {this._renderErrorMessageOrTable(filteredGames)}
                    </div>
                );
            }
        }
    )
);




